import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgMoneyBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.867 12a1.335 1.335 0 0 0-1.2-.667h-1.334a1.334 1.334 0 0 0 0 2.666h1.334a1.333 1.333 0 1 1 0 2.667h-1.334a1.333 1.333 0 0 1-1.2-.667M12 10v1.333m0 5.334V18M9.5 3h5c.298 0 .585.126.796.351.21.226.329.53.329.849 0 .743-.277 1.455-.769 1.98-.492.525-1.16.82-1.856.82h-2a2.545 2.545 0 0 1-1.856-.82 2.898 2.898 0 0 1-.769-1.98c0-.318.119-.623.33-.849A1.09 1.09 0 0 1 9.5 3ZM3 16.692v-1.077c0-2.285.948-4.476 2.636-6.092C7.324 7.908 9.613 7 12 7s4.676.908 6.364 2.523C20.052 11.14 21 13.33 21 15.615v1.077a4.216 4.216 0 0 1-1.318 3.046A4.604 4.604 0 0 1 16.5 21h-9a4.604 4.604 0 0 1-3.182-1.262A4.216 4.216 0 0 1 3 16.692Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export { SvgMoneyBag as default };
